import { Flask } from "@phosphor-icons/react";

export default function ComplianceBar() {
  return (
    <div
      className="w-full border-b border-cyan/15 bg-navy-deep py-1.5 text-center"
      data-testid="compliance-bar"
    >
      <p className="flex items-center justify-center gap-2 px-4 font-mono text-[10px] uppercase tracking-[0.18em] text-teal sm:text-xs">
        <Flask size={13} weight="fill" className="text-cyan" />
        Strictly for research use only — not for human consumption
      </p>
    </div>
  );
}
